export default {
 TOOLTIP_CAN_GENERATE:'Can\'t decide between a Convertible Loan Note or a SAFE? Read the guide.',
 TOOLTIP_CANT_GENERATE:'You\'re all out of free documents. Scale up to generate all the key legal documents you need. ',
 TITLE:'Generate a Convertible Loan Note or SAFE for these convertibles',
 SUBTITLE:'Add convertibles'
}